import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qg29vqjs6u: FaireBrandEntity = {
  token: "b_qg29vqjs6u",
  type: "brand",
  name: "Accessiorie (We Pay All Duties)",
  avatarUrl:
    "https://cdn.faire.com/fastly/e3ecefe8e4ece087fbe2aa75cda4acc1f5f0bb87547d66c0071f1e6a746d4634.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/cd7a778966ab840395cc13448cfa17e96015b0e26e49f3437185b614d07ef487.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e3ecefe8e4ece087fbe2aa75cda4acc1f5f0bb87547d66c0071f1e6a746d4634.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cd7a778966ab840395cc13448cfa17e96015b0e26e49f3437185b614d07ef487.png",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 200,
  rating: 4.4,
  reviewCount: 21,
  isInsider: false,
  description:
    "Established in 2026, Accessiorie LLC began as an accessories company focused on sourcing fun, trend-forward products that customers love. As demand for squishies and sensory toys rapidly grew, we recognized an opportunity to expand our expertise and become a trusted supplier in one of the fastest-growing product categories in the market.\n\nToday, Accessiorie specializes in sourcing high-quality squishies, sensory toys, keychains, and novelty accessories that help retailers attract customers, increase repeat purchases, and stay ahead of emerging trends. Our team carefully selects products based on quality, visual appeal, and customer demand, ensuring our partners receive items that perform well both online and in-store.\n\nWe understand what today's shoppers are looking for because we continuously monitor market trends and customer preferences. Whether you're a gift shop, toy store, boutique, convenience store, or online retailer, we're committed to providing unique, eye-catching products backed by dependable service, competitive pricing, and consistent inventory.\n\nAt Accessiorie, our goal is simple: help our retail partners grow their business with products that bring joy, encourage impulse purchases, and keep customers coming back for more. ✨",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:55.175Z",
    importedBy: "entity-db-cli",
  },
};
